import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { AbilityActions } from './ability.store';
import { RoleHttpClient } from '../services/role-http-client';

@Injectable({ providedIn: 'root' })
export class AbilityEffects {
  private readonly roleHttpClient = inject(RoleHttpClient);
  private readonly actions$ = inject(Actions);

  public effect = createEffectFactory(AbilityActions, this.actions$);

  public fetchAbilities$ = this.effect(AbilityActions.fetch, () =>
    this.roleHttpClient.fetchAbilities(),
  );
}
